const resultsPositionMap = {
  EPvsBB: 'UTGvsBB',
  BUvsSB: 'BTNvsSB',
  BUvsBB: 'BTNvsBB',
  BBvsEP: 'UTGvsBB',
  SBvsBU: 'BTNvsSB',
  BBvsBU: 'BTNvsBB',
  BUvsEP: 'UTGvsBTN',
  BUvsCO: 'COvsBTN',
  BBvsSB: 'SBvsBB',
  EPvsBU: 'UTGvsBTN',
  COvsBU: 'COvsBTN',
  EPvsSB: 'UTGvsSB',
  SBvsEP: 'UTGvsSB',
};

const threeBetRequestPositionMap = {
  BTNvsSB: 'SBvsBTN',
  COvsBTN: 'BTNvsCO',
  SBvsBB: 'BBvsSB',
  UTGvsBTN: 'BTNvsUTG',
  UTGvsSB: 'SBvsUTG',
};

const normalizePostflopResultsPosition = (spot = '') => {
  const baseSpot = spot.split('_')[0];
  return resultsPositionMap[baseSpot] || baseSpot;
};

export const normalizePostflopRequestPosition = (positionType = '', spot = '', game = '') => {
  if (String(game).replace(/^5c_/i, '').toLowerCase() === 'hu') return '';

  const position = normalizePostflopResultsPosition(spot);

  if (positionType !== '3bP') return position;
  return threeBetRequestPositionMap[position] || position;
};

// Stats use the exact Challenge category, including hero and action. Physical
// table keys (or the old HU aggregate) cannot identify those separate results.
export const normalizePostflopStatPosition = (positionType, spot = '') => spot;

export const normalizePostflopGame = (game = '', isPlo5 = false) => {
  const rawValue = String(game);
  const unprefixedValue = rawValue.replace(/^5c_/i, '');

  if (!isPlo5) return rawValue.toLowerCase() === 'hu' ? 'HU' : rawValue;
  if (unprefixedValue.toLowerCase() === 'hu') return '5c_HU';
  return `5c_${unprefixedValue}`;
};

export const resolvePostflopDataLocation = ({
  game = '',
  isPlo5 = false,
  positionType = '',
  spot = '',
} = {}) => {
  const normalizedGame = normalizePostflopGame(game, isPlo5);
  const normalizedPosition = normalizePostflopRequestPosition(positionType, spot, game);

  return {
    game: normalizedGame,
    positionType,
    position: normalizedPosition,
  };
};

export default normalizePostflopResultsPosition;
